const DetailDrawer = ({ open, title, onClose, children }) => {
  if (!open) return null;

  return (
    <>
      <div className="dashboard-drawer-backdrop" onClick={onClose} role="presentation" />
      <div className="dashboard-drawer" role="dialog" aria-label={title}>
        <div className="dashboard-drawer__header">
          <h3 style={{ margin: 0 }}>{title}</h3>
          <button type="button" className="dashboard-btn dashboard-btn--secondary" onClick={onClose}>
            Close
          </button>
        </div>
        <div className="dashboard-drawer__body">{children}</div>
      </div>
    </>
  );
};

export default DetailDrawer;
